module.exports = __webpack_public_path__ + "static/media/logo.9ab81344.png";